export default {
  connectToDataSource: 'Pripojiť k zdroju dát',
  noDataSourceFound: 'Toto zariadenie nie je pripojené k žiadnemu podporovanému SCADA systému ani kontroléru',
};
